import React from 'react';
import { useTranslation } from 'react-i18next';

// TREATX-TAX-5 — read-only projection of the provider's treatment VAT.
// Strict consumer of the backend `financial_summary`: it performs no
// arithmetic, and renders NOTHING when the provider made no declaration
// (an absent declaration is not a confirmed 0%).
export const ProviderTaxBreakdown = ({ financialSummary, currencySym = '', testId = 'provider-tax-breakdown' }) => {
  const { t } = useTranslation();
  const fs = financialSummary || {};
  if (fs.tax_status !== 'DECLARED') return null;

  const money = (v) => `${currencySym}${Number(v ?? 0).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
  const ratePct = (fs.tax_rate_bps || 0) / 100;
  const applicable = fs.tax_treatment === 'VAT_APPLICABLE' && ratePct > 0;

  return (
    <div className="text-xs text-slate-600 space-y-1" data-testid={testId}>
      <div className="flex justify-between gap-6" data-testid={`${testId}-net`}>
        <span>{t('offer.tax.netAmount')}</span>
        <span className="font-medium">{money(fs.net_total)}</span>
      </div>
      <div className="flex justify-between gap-6" data-testid={`${testId}-vat`}>
        <span>{applicable ? t('offer.tax.vatAt', { rate: ratePct }) : t('offer.tax.treatmentExempt')}</span>
        <span className="font-medium">{money(fs.vat_amount)}</span>
      </div>
      <div className="flex justify-between gap-6 pt-1 border-t" data-testid={`${testId}-patient-total`}>
        <span>{t('offer.tax.patientTotal')}</span>
        <span className="font-semibold">{money(fs.patient_total ?? fs.total)}</span>
      </div>
      {fs.tax_exemption_reason && (
        <p className="text-slate-500" data-testid={`${testId}-reason`}>
          {t('offer.tax.reason')}: {fs.tax_exemption_reason}
        </p>
      )}
      <p className="text-slate-400" data-testid={`${testId}-declared-by`}>{t('offer.tax.declaredByProvider')}</p>
    </div>
  );
};

export default ProviderTaxBreakdown;
